<script>
import iframeResize from 'iframe-resizer/js/iframeResizer';

export default {
  name: 'IframeWrapper',
  props: {
    id: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.$el.addEventListener('load', () => iframeResize({
      heightCalculationMethod: 'documentElementOffset',
    }, this.$el));
  },
};
</script>
<template>
  <iframe
    :id="this.id"
    :height="this.height"
    :src="this.url"
    :title="this.title"
  />
</template>
